import React from "react"



export default function TrxDetailBlock({
  mergeSide, 
  className="", children 
}:{ 
  mergeSide?:string; 
  className?:string; 
  children:React.ReactNode 
}){
  return (
    <div 
      style={{
        width: "100%",
        marginLeft: "12px",
        marginBottom: "0.75rem",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #d1d5db",
        borderRightColor: mergeSide === "left" ? "transparent" : "#d1d5db",
        borderLeftColor: mergeSide === "right" ? "transparent" : "#d1d5db",
      }}
    >
      { children}
    </div>
  )
}